import * as constant from '../constants/ActionTypes';
import { modalChannels } from '../constants/UtilVariables';

function login(currentUri) {
  window.open(`/signin/?returnUri=${currentUri}`, '_self');
  return {
    type: constant.LOGIN_SIGNIN_REDIRECT,
    payload: currentUri,
  };
}

function dispatchCallUs(currentUri, topic) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_CALLUS,
      payload: topic,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

function dispatchEmailUs(currentUri, topic) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_EMAIL,
      payload: topic,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

function dispatchEmailUsNoIntent(currentUri) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_EMAIL_NO_INTENT,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

function dispatchChatBotChannel(currentUri, topic) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_CHAT_BOT,
      payload: topic,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

function dispatchChatChannel(currentUri, topic) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_CHAT,
      payload: topic,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

function dispatchMessageUsChannel(currentUri, topic) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_MESSAGE_US,
      payload: topic,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

export default function dispatchLogin(currentUri, channel, topic = {}) {
  if (channel === modalChannels.call) {
    return dispatchCallUs(currentUri, topic);
  }
  if (channel === modalChannels.defaultEmail) {
    return dispatchEmailUsNoIntent(currentUri);
  }
  if (channel === modalChannels.chatBot) {
    return dispatchChatBotChannel(currentUri, topic);
  }
  if (channel === modalChannels.chat) {
    return dispatchChatChannel(currentUri, topic);
  }
  if (channel === modalChannels.messageUs) {
    return dispatchMessageUsChannel(currentUri, topic);
  }

  return dispatchEmailUs(currentUri, topic);
}

export const exportedForTesting = {
  dispatchCallUs,
  dispatchEmailUs,
  dispatchEmailUsNoIntent,
  dispatchChatBotChannel,
  dispatchChatChannel,
  dispatchMessageUsChannel,
  dispatchLogin,
};
